/* FacetWP Map: let the map fit all markers first, then enable
   filtering so subsequent pan/zoom constrains the results. */
(function() {
	var mapReady = false;
	document.addEventListener( 'facetwp-maps-loaded', function() {
		if ( mapReady || typeof FWP_MAP === 'undefined' || ! FWP_MAP.map ) return;
		mapReady = true;
		// Wait for the initial fitBounds to settle, then arm filtering
		google.maps.event.addListenerOnce( FWP_MAP.map, 'idle', function() {
			FWP_MAP.is_filtering = true;
		} );
	} );
})();

/* Header entrance */
const { gsap, ScrollTrigger } = window;

if ( ! window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches ) {
	const header = document.querySelector( 'header' );
	if ( header ) {
		gsap.fromTo(
			header,
			{ opacity: 0 },
			{
				opacity: 1,
				duration: 0.7,
				ease: 'power2.out',
				clearProps: 'opacity',
			}
		);
	}
}

/* Footer image parallax */
const footerBg = document.getElementById( 'footer-bg' );
if ( footerBg ) {
	gsap.fromTo(
		footerBg,
		{ y: 0 },
		{
			y: -120,
			ease: 'none',
			scrollTrigger: {
				trigger: '#footer',
				start: 'top bottom',
				end: 'bottom top',
				scrub: true,
			},
		}
	);
}

import("../../../Social-Sorbet/assets/js/splide.js")
	.then(({ Splide }) => {
		/**
		 * Initialize Splide on every listing card gallery slider.
		 * Scoped to `.splide` inside a listing card article so other
		 * sliders on the page are unaffected.
		 */
		function initListingCardSliders( root = document ) {
			const sliders = root.querySelectorAll( "article .splide:not(.is-initialized)" );

			sliders.forEach( ( el ) => {
				new Splide( el, {
					type       : "fade",
					arrows     : true,
					pagination : true,
					perPage    : 1,
					perMove    : 1,
					gap        : 0,
					rewind     : true,
				} ).mount();
			} );
		}

		// Initialize sliders already in the DOM.
		initListingCardSliders();

		// Re-initialize after FacetWP or any other AJAX refresh injects new cards.
		document.addEventListener( "facetwp-loaded", () => initListingCardSliders() );

		// Fallback: watch for dynamically added listing cards via MutationObserver.
		const observer = new MutationObserver( ( mutations ) => {
			mutations.forEach( ( mutation ) => {
				mutation.addedNodes.forEach( ( node ) => {
					if ( node.nodeType !== Node.ELEMENT_NODE ) return;
					initListingCardSliders( node );
				} );
			} );
		} );

		observer.observe( document.body, { childList: true, subtree: true } );
	} )
	.catch( ( err ) => {
		console.error( err );
	} );

	// QR form code submission
	if ($('#sfdc-web-to-lead').length) {
		const form = $('#sfdc-web-to-lead');

		form.on('submit', function(e) {
			e.preventDefault(); // stop normal redirect
			form.addClass('loading');
			form.find('input[type="submit"]').prop('disabled', true);

			// Validate required fields before AJAX
			var isValid = true;
			form.find('input[required]').each(function() {
				var input = $(this);
				if ((!input.val() || input.val().trim() === "") && (!input.data('selected') || input.data('selected') === "")) {
					isValid = false;
					input.addClass('field-error');
				} else {
					input.removeClass('field-error');
				}
			});

			if (!isValid) {
				form.removeClass('loading');
				form.find('input[type="submit"]').prop('disabled', false);
				return;
			}

			// Prepare form data for WordPress AJAX
			var formData = form.serialize();
			formData += '&action=submit_to_salesforce';
			formData += '&nonce=' + (window.salesforce_nonce || '');
			formData += '&salesforce_endpoint=' + encodeURIComponent(form.attr('action') || '');

			$.ajax({
				type: 'POST',
				url: window.ajax_url || '/wp-admin/admin-ajax.php',
				data: formData,
				dataType: 'json'
			}).done(function(response) {
				if (response.success) {
					form.html("<h4>Success! Thank you for registering.</h4>");
					$("#instructions").hide();
				} else {
					console.error('Form submission failed:', response.data);
					alert('There was an error submitting the form: ' + (response.data || 'Please try again later.'));
				}
			}).fail(function(xhr, status, error) {
				console.error('AJAX request failed:', error);
				alert('There was an error submitting the form. Please try again later.');
			}).always(function() {
				form.removeClass('loading');
				form.find('input[type="submit"]').prop('disabled', false);
			});
		});
	}